import {
  baseURLMain,
  baseURLProd,
  baseURLQA,
  baseURLRelease,
} from "../utils/constants";

const alpha = {
  apiGateWay: {
    URL: baseURLQA,
  },
};
const beta = {
  apiGateWay: {
    URL: baseURLRelease,
  },
};
const main = {
  apiGateWay: {
    URL: baseURLMain,
  },
};
const prod = {
  apiGateWay: {
    URL: baseURLProd,
  },
};

export const Config =
  process.env.REACT_APP_STAGE === "prod"
    ? prod
    : process.env.REACT_APP_STAGE === "dev"
      ? alpha
      : alpha;

console.log(process.env.REACT_APP_STAGE);
